import { money, fmtDate } from "../../lib/format";

export const RecentPayments = ({ items }) => (
  <div className="bg-white rounded-[2rem] border border-black/5 p-6" data-testid="recent-payments">
    <p className="eyebrow text-[#E07A5F]">Son Ödemelerim</p>
    {items.length === 0 && <p className="text-sm text-slate-500 mt-4">Kayıtlı ödeme bulunmuyor.</p>}
    <ul className="mt-3 divide-y divide-black/5 max-h-72 overflow-y-auto">
      {items.slice(0, 8).map((p, i) => (
        <li key={p.id || i} className="py-3 flex items-center justify-between gap-3" data-testid={`recent-payment-${i}`}>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-800 truncate">{p.description || "Ödeme"}</p>
            <p className="text-xs text-slate-400">{fmtDate(p.date)} · {p.payment_method}</p>
          </div>
          <span className="text-sm font-bold text-[#1B4332] shrink-0">{money(p.amount)}</span>
        </li>
      ))}
    </ul>
  </div>
);
